import { getTeamUrl } from 'Common'

export default () => (dispatch, getState) => {

  const { subcontractor } = getState().screens.SubcontractorView

  window.open(getTeamUrl(`subcontractors/${subcontractor.id}/rate_history/export`, 'exports'))

}
